module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/close-bfa29482b68dc59ac4d1754714631d55.svg";